import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white py-16 px-4 border-y-4 border-navy" data-id="element-78">
      <div className="max-w-3xl mx-auto text-center" data-id="element-79">
        <ShieldCheck className="w-20 h-20 md:w-24 md:h-24 text-green mx-auto mb-6" data-id="element-80" />
        <h2 className="text-3xl md:text-5xl font-heading font-black text-navy mb-6" data-id="element-81">
          🛡️ 7-DAY GUARANTEE — NO QUESTIONS ASKED
        </h2>
        <div className="space-y-4 text-lg md:text-xl text-ink/90 mb-8 font-medium" data-id="element-82">
          <p data-id="element-83">No forms. No drama. No explanations.</p>
          <p className="font-bold text-2xl text-white bg-green inline-block px-6 py-3 rounded-xl shadow-md mt-2" data-id="element-84">
            Try it. Print it. Use it. If you don't see a difference — you pay
            nothing.
          </p>
        </div>
        <div className="inline-block bg-lightgray text-navy px-6 py-3 rounded-full font-bold shadow-sm border border-border" data-id="element-85">
          <p data-id="element-86">🛡️ Refund rate: less than 1%.</p>
        </div>
      </div>
    </section>;
}